import { render, staticRenderFns } from "./PaymentBanks.vue?vue&type=template&id=1db3716b&scoped=true&"
import script from "./PaymentBanks.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PaymentBanks.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PaymentBanks.vue?vue&type=style&index=0&id=1db3716b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db3716b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PaymentAllBanksButton: require('/usr/www/nuxt/components/Payment/PaymentAllBanksButton.vue').default,BaseClickedCheckbox: require('/usr/www/nuxt/components/Base/BaseClickedCheckbox.vue').default,BaseInput: require('/usr/www/nuxt/components/Base/BaseInput.vue').default,PaymentAllBanks: require('/usr/www/nuxt/components/Payment/PaymentAllBanks.vue').default,PaymentModals: require('/usr/www/nuxt/components/Payment/PaymentModals.vue').default})
